const ScanActionTypes = {
  AGREEMENTS_LOADED: 'AGREEMENTS_LOADED',
  AGREEMENT_SELECTED: 'AGREEMENT_SELECTED',
  AGREEMENT_SAVING: 'AGREEMENT_SAVING',
  CHANNEL: 'CHANNEL',

  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  LOGIN_START: 'LOGIN_START',
  LOGGED_IN: 'LOGGED_IN',
  LOGGIN_FAILED: 'LOGIN_FAILED',
  CLEAR_ERROR: 'CLEAR_ERROR',
  RESET_SENT: 'RESET_SENT',
  RESET_FAIELD: 'RESET_FAILED'
};

export default ScanActionTypes;



// WEBPACK FOOTER //
// ./src/data/AgrActionTypes.js